import * as React from "react";
import { AuthenticatedUser } from "../../";
import { creators, RelodeAppActionTypes } from "./relodeAppActionTypes";
import { TeamPlanFeatures } from "./teamPlanFeatures";

export const useRelodeAppActions = (
    dispatch: React.Dispatch<RelodeAppActionTypes>
) => {
    const actions = React.useMemo(
        () => ({
            apiCallSuccess: () => dispatch(creators.apiCallSuccessful()),
            apiCallFailure: () => dispatch(creators.apiCallFailure()),
            appOffline: () => dispatch(creators.appOffline()),
            appOnline: () => dispatch(creators.appOnline()),
            setCurrentUser: (user: AuthenticatedUser) =>
                dispatch(creators.setCurrentUser(user)),
            setTeamPlanFeatures: (teamPlanFeatures: TeamPlanFeatures) =>
                dispatch(creators.setTeamPlanFeatures(teamPlanFeatures)),
            openMenu: () => dispatch(creators.openMenu()),
            closeMenu: () => dispatch(creators.closeMenu()),
            toggleMenu: () => dispatch(creators.toggleMenu()),
        }),
        [dispatch]
    );

    return actions;
};
